import { useQuery } from '@tanstack/react-query';

import { getZendeskNoticesApi } from './api';

export function useZendeskNotices() {
  // 일반 공지 로딩
  const { data: notices } = useQuery({
    queryKey: ['getZendeskNoticesApi'],
    queryFn: getZendeskNoticesApi,
    select: (res) => {
      if (!res.data?.articles) return [];
      return res.data.articles.slice(0, 5); // 최근 5개만 노출
    },
  });

  return { notices };
}
